var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"locationFilter"},[_c('base-multi-select',{attrs:{"list":this.states,"value":_vm.value,"label":"label","track-by":"id"},on:{"input":_vm.input}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }